module.exports = __webpack_public_path__ + "static/media/ae-logo.d34ca9da.svg";